import { Box, Text } from '@factorialco/deprecated-design-system'
import { Spinner } from '@factorialco/f0-react/dist/experimental'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { Separator } from 'modules/integrations/components/SyncFooter/Separator'
import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

const formatDate = (date: string) => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_month_day_time')
}

export const LastSync = () => {
  const { isSyncRunning, lastSyncRun } = useIntegrationsSyncContext()

  if (!lastSyncRun) return null
  return (
    <>
      {isSyncRunning ? (
        <Box flexDirection="row" gap="s8" alignItems="center">
          <Spinner size="small" />
          <Text.Normal color="grey800" size="200" weight="medium">
            {i18n.t('integrations.syncable_status.syncing')}
          </Text.Normal>
        </Box>
      ) : (
        <>
          <Text.Normal color="grey700" size="200">
            {i18n.t('integrations.footer.last_sync')}
          </Text.Normal>
          <Text.Normal color="grey800" size="200" weight="medium">
            {formatDate(lastSyncRun.finishedAt)}
          </Text.Normal>
        </>
      )}
      <Separator />
    </>
  )
}
